import { useState, useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"

const useCustomerDocumentStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('customer_document_statuses_last_updated', 0)
    const [customerDocumentStatuses, setCustomerDocumentStatuses] = useLocalStorage('customer_document_statuses', [])
    
    useEffect(() => {
        if( customerDocumentStatuses.length === 0 ) {
            reload()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reload()
    }, [])

    const reload = () => {
        setLastUpdated(Date.now())
        fetch('/v0/customer_document_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                const statuses = json.results
                setCustomerDocumentStatuses(statuses)
            })
            .catch(error => {
                console.log("CustomerDocumentStatuses reload error", error)
            })
    }

    return {
        customerDocumentStatuses,
    }
}

export default useCustomerDocumentStatuses
